type CarrotModalStorage = {
  hasCrrModalTriggeredThisSession?: boolean
}

export const CARROT_MODAL_STORAGE_KEY = "carrotModalStorage"

export const getCarrotModalStorage = (): CarrotModalStorage => {
  try {
    return JSON.parse(localStorage.getItem(CARROT_MODAL_STORAGE_KEY)) ?? {}
  } catch {
    return {}
  }
}

export const updateCarrotModalStorage = (shouldCrrModalRender: boolean) => {
  const carrotModalStorage = {
    hasCrrModalTriggeredThisSession: shouldCrrModalRender
  }
  localStorage.setItem(CARROT_MODAL_STORAGE_KEY, JSON.stringify(carrotModalStorage))
}

export const resetCarrotModalStorage = (): void => {
  localStorage.removeItem(CARROT_MODAL_STORAGE_KEY)
}
